module.exports = __webpack_public_path__ + "img/sb_march83_p2.7c0fb3f5.jpg";